import { createListenerMiddleware } from "@reduxjs/toolkit";
import { loginSuccess, logout, setUser } from "./authSlice";
import { markAuthLogout, markAuthPresence } from "../utils/authPresence";

export const authPresenceMiddleware = createListenerMiddleware();

authPresenceMiddleware.startListening({
  actionCreator: loginSuccess,
  effect: async (action) => {
    const token = action.payload?.token;
    if (token) {
      await markAuthPresence(token, true);
    }
  },
});

authPresenceMiddleware.startListening({
  actionCreator: setUser,
  effect: async (_, api) => {
    const token = api.getState()?.auth?.token;
    if (token) {
      await markAuthPresence(token, true);
    }
  },
});

authPresenceMiddleware.startListening({
  actionCreator: logout,
  effect: async (_, api) => {
    const previousToken = api.getOriginalState?.()?.auth?.token;
    if (previousToken) {
      await markAuthLogout(previousToken, true);
    }
  },
});
